<template>
  <div>
    <div class="search-panel">
      <a-radio-group v-if="!batch" v-model="baseQueryParam.checked" @change="onCheckedChange" >
        <a-radio-button :value="'0'">
          未审核
        </a-radio-button>
        <a-radio-button :value="'1'">
          审核通过
        </a-radio-button>
        <a-radio-button :value="'2'">
          审核未通过
        </a-radio-button>
      </a-radio-group>
      <a-button class="search-item-com"  @click="supperSearchView">{{batch?'筛选':'高级筛选'}}</a-button>
      <slot name="btn"></slot>
      <template v-if="handleStatusQuery">
        <label style="margin-left: 10px">
          处理状态
        </label>
        <a-select style="width: 120px;margin-left: 10px" v-model="baseQueryParam.handleStatus" allowClear placeholder="请选择">
          <a-select-option value="1" >未处理</a-select-option>
          <a-select-option value="2" >已处理</a-select-option>
        </a-select>
      </template>
      <template v-if="this.period.groupSet ==='1' && !batch">
        <label style="margin-left: 10px">
          {{this.period.groupTypeName || '分组'}}
        </label>
        <a-select style="width: 100px;margin-left: 10px" v-model="addGroupName" @change="selectGroup2" allowClear showSearch placeholder="请选择">
          <!-- <a-select-option value="" ></a-select-option> -->
          <a-select-option :value="num" v-for="(num, index) in leftTopNumbers" :key="num">{{num}}</a-select-option> 
          <a-select-option :value="num" v-for="(num, index) in rightTopNumbers" :key="num">{{num}}</a-select-option>
          <a-select-option :value="num" v-for="(num, index) in leftBottomNumbers" :key="num">{{num}}</a-select-option>
          <a-select-option :value="num" v-for="(num, index) in rightBottomNumbers" :key="num">{{num}}</a-select-option>         
        </a-select>
      </template>      
      <template v-if="!batch">
        <a-input :disabled="!!queryParam.patientName" class="search-item-com" v-model="queryParam.input" placeholder="请输入编号/姓名" style="width: 400px"></a-input>
        <a-tag closable color="blue" @close="patientNameClose" v-if="queryParam.patientName" style="margin-left: 10px;">
          {{queryParam.patientName||queryParam.patientNum}}
        </a-tag>
        <a-button class="search-item-com" type="primary" @click="searchQueryMy">查询</a-button>
        <a-button class="search-item-com" @click="searchReset">重置</a-button>
      </template>      
    </div>
    <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="showBatchCheck">
      <i class="anticon anticon-info-circle ant-alert-icon">
      </i> 已选择 <a><b>{{ selectedRowKeys.length }}</b></a>项
      <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      <a-button type="primary" style="margin-left: 24px" @click="handleBatchCheck">批量审核</a-button>
    </div>
    <template v-if="this.periodGroups.length>0 && this.period.groupSet ==='1' && !batch">
      <a-tabs :activeKey="activeGroupName" @change="callbackGroupName">
        <a-tab-pane :key="item.groupName" :tab="item.groupName" v-for="(item, index) in periodGroups">          
        </a-tab-pane>        
      </a-tabs>
    </template>
    <a-table
      ref="table"
      size="middle"
      :scroll="{x:'100%'}"
      rowKey="id"
      :columns="filteredColumns"
      :locale="{emptyText: batch?'请选择有数据的表单查询':'暂无数据'}"
      :dataSource="dataSource"
      :pagination="ipagination"
      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
      :loading="loading"
      @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleView(record)">查看</a>
          <template v-if="baseQueryParam.checked === '0' || baseQueryParam.checked === '2'">
            <a-divider type="vertical" />
            <a @click="handleCheck(record)">审核完成</a>
          </template>
        </span>
    </a-table>
    <a-modal
      title="高级筛选"
      :width="'80%'"
      :visible="advancedVisible"
      :footer="null"
      @cancel="handleAdvancedCancel">

      <a-checkbox-group v-model="queryParam2.centerIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            研究中心：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6" v-for="(center,index) in centerList" :key="index">
                <a-checkbox :value="center.center.id">
                  {{center.center.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.personIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            研究员：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6" v-for="(user,index) in userList" :key="index">
                <a-checkbox :value="user.userId">
                  {{user.realname}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.userIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            提交人：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6" v-for="(user,index) in userList" :key="index">
                <a-checkbox :value="user.userId">
                  {{user.realname}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.periodItemIdList" @change="periodItemIdChange" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            周期：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6" v-for="(periodItem,index) in periodItemList" :key="index">
                <a-checkbox :value="periodItem.id">
                  {{periodItem.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.formIdList" @change="formIdChange" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            表单：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6" v-for="(form,index) in formList" :key="index">
                <a-checkbox :value="form.id">
                  {{form.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-row>
        <a-col :span="4" class="advanced-label">
          表单提交时间：
        </a-col>
        <a-col :span="20">
          <a-range-picker v-model="queryParam2.submitTimeList"  valueFormat="YYYY-MM-DD"/>
        </a-col>
      </a-row>

       <a-checkbox-group v-model="queryParam2.checkUserIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            表单审核人：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6" v-for="(user,index) in checkUserList" :key="index">
                <a-checkbox :value="user.checkedUser">
                  {{user.checkedUserName}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>

       <a-row>
        <a-col :span="4" class="advanced-label">
          表单审核时间：
        </a-col>
        <a-col :span="20">
          <a-range-picker v-model="queryParam2.checkTimeList"  valueFormat="YYYY-MM-DD"/>
        </a-col>
      </a-row>
        <a-row v-if="this.period.groupSet ==='1' && !batch" style="margin-top:10px;">
          <a-col :span="4" class="advanced-label">
            {{this.period.groupTypeName || '分组'}}：
          </a-col>
        <!-- 左上角部分 -->
        <a-col :span="10">
          <a-row :gutter="6">
            <a-col :span="3" v-for="(num, index) in leftTopNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" :title="addGroupName === num?'再次点击取消选择':''" @click="selectGroup(num)">{{ num }}</div>              
            </a-col>
          </a-row>
          <a-row :gutter="6">
            <a-col :span="3" v-for="(num, index) in leftBottomNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" :title="addGroupName === num?'再次点击取消选择':''" @click="selectGroup(num)">{{ num }}</div>
            </a-col>
          </a-row>
        </a-col>

        <!-- 右上角部分 -->
        <a-col :span="10">
          <a-row :gutter="6">
            <a-col :span="3" v-for="(num, index) in rightTopNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" :title="addGroupName === num?'再次点击取消选择':''" @click="selectGroup(num)">{{ num }}</div>
            </a-col>
          </a-row>
          <a-row :gutter="6">
            <a-col :span="3" v-for="(num, index) in rightBottomNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" :title="addGroupName === num?'再次点击取消选择':''" @click="selectGroup(num)">{{ num }}</div>
            </a-col>
          </a-row>
        </a-col>        
      </a-row>
      <div style="text-align: right">
        <a-button type="primary" @click="handleAdvancedSubmit">查询</a-button>
      </div>


    </a-modal>

    <a-modal
      :visible="checkedVisible"
      title="表单审核"
      :width="'50%'"
        @ok="handleSubmit"
        @cancel="handleCancel"
        :okText="'提交'"
        :cancelText="'取消'"
      >
        <a-form>
          <a-form-item label="是否审核通过" :labelCol="{ span: 5 }" :wrapperCol="{ span: 15 }">
            <a-radio-group v-model="formCheck.checked">
              <a-radio :value="1">通过</a-radio>
              <a-radio :value="2">未通过</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="表单语音质量评价" :labelCol="{ span: 5 }" :wrapperCol="{ span: 15 }">
            <a-textarea v-model="formCheck.voiceEvaluate" placeholder="请输入表单语音质量评价"></a-textarea>
            <a-button-group>
              <a-button v-for="tag in tags" :key="tag" @click="appendTag(tag)">
                {{ tag }}
              </a-button>
            </a-button-group>
          </a-form-item>
        </a-form>
      </a-modal>

      <a-modal
        title="查看表单"
        :visible="viewVisible"
        :footer="null"
        @cancel="viewVisible = false"
        width="80%"
        destroyOnClose
      >
        <check-form
          :formId="viewFormId"
          :showFile="true"
          :showTitle="true"
          :key="'checkview-'+viewFormId"
        />
      </a-modal>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction ,postAction} from '@/api/manage'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import CheckForm from '../CheckForm'
  export default {
    name: 'CheckList',
    components: { CheckForm },
    mixins: [JeecgListMixin],
    props:{
      // 批量审核
      batch:{
        type:Boolean,
        default:false,
      },
      selected:{
        type:Boolean,
        default:false,
      },
      baseQuery:{
        type:Object,
        default:()=>{
          return {}
        },
      },
      handleStatusQuery:{
        type:Boolean,
        default:false,
      },
    },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        advancedVisible:false,
        checkedVisible:false,
        viewVisible:false,
        centerList:[],
        userList:[],
        checkUserList:[],
        periodItemList:[],
        formList:[],
        queryParam2:{},
        formCheck:{
          checked:"1",
          id:"",
          voiceEvaluate:"",
        },//默认审核通过
        tags: ['好', '一般', '差'],
        period:{groupSet:'0',groupTypeName:''},
        columns:[
          {
            title: '受试者编号',
            width: 120,
            dataIndex: 'patientNum',
            align: 'center', 
          },
          {
            title: '受试者姓名',
            width: 100,
            dataIndex: 'patientName',
             align: 'center', 
          },
          {
            title: '研究中心',
            width: 150,
            dataIndex: 'centerName',
             align: 'center', 
          },
          
          {
            title: '研究员',
            width: 100,
            dataIndex: 'personName',
             align: 'center', 
          },
          {
            title: '分组',
            width: 100,
            dataIndex: 'groupName',
             align: 'center', 
          },
          {
            title: '周期',
            width: 100,
            dataIndex: 'periodItemName',
             align: 'center', 
          },
          {
            title: '表单名称',
            width: 150,
            ellipsis: true,
            dataIndex: 'name',
             align: 'center', 
          },
          {
            title: '提交人',
            width: 100,
            dataIndex: 'userRealname',
             align: 'center', 
          },
          {
            title: '提交时间',
            width: 150,
            dataIndex: 'submitTime',
             align: 'center', 
             sorter: true,
          },
          {
            title: '表单完成度',
            width: 100,
            dataIndex: 'completionRate',
             align: 'center', 
            customRender:(text,row)=> {
              if(!row.itemCount){
                return ''
              }
              return ((row.itemValueCount / row.itemCount) * 100).toFixed(2) +'%'
            }
          },
          {
            title: '未关闭质疑数',
            width: 120,
            dataIndex: 'questionCount',
             align: 'center', 
          },
          {
            title: '已处理质疑数',
            width: 120,
            dataIndex: 'handleQuestionCount',
             align: 'center', 
          },
          {
            title: '未处理质疑数',
            width: 120,
            dataIndex: 'notHandleQuestionCount',
             align: 'center', 
          },
           {
            title: '审核人',
            width: 100,
            dataIndex: 'checkedUserName',
             align: 'center', 
          },
          {
            title: '审核时间',
            width: 150,
            dataIndex: 'checkedTime',
             align: 'center', 
             sorter: true,
          },

        ],
        url:{
          list:'/patient/patientForm/checkList'
        },
        disableMixinCreated:true,        
        leftTopNumbers: [17, 16, 15, 14, 13, 12, 11],
        leftBottomNumbers: [47, 46, 45, 44, 43, 42, 41],
        rightTopNumbers: [21, 22, 23, 24, 25, 26, 27],
        rightBottomNumbers: [31, 32, 33, 34, 35, 36, 37],
        addGroupName: undefined,
        activeGroupName: '',
        periodGroups: [],
        selectedRowKeys: [],
        viewVisible: false,
        viewFormId: '',
      }
    },
    computed: {
      filteredColumns (){        
        let columnList = this.columns
        if(this.period.groupSet !=='1'){
          columnList = columnList.filter(item => item.dataIndex!='groupName')
        }else{
          columnList.filter(item => item.dataIndex==='groupName').forEach(item=>{
            item.title = this.period.groupTypeName || '分组'
          })
        }
        if(this.baseQueryParam.checked ==='0'){
            return columnList.filter(item => item.title!='未关闭质疑数'&& item.title!='审核人' && item.title!='审核时间')
        }
        else if(this.baseQueryParam.checked ==='1'){
            return columnList.filter(item => item.title!='表单完成度' && item.title!='未处理质疑数' && item.title!='未关闭质疑数')
        }
        else if(this.baseQueryParam.checked ==='2'){
          return columnList.filter(item => item.title!='表单完成度' && item.title!='未关闭质疑数' && item.title!='审核人' && item.title!='审核时间')
        }
        return columnList.filter(item => item.title!='已处理质疑数' && item.title!='未处理质疑数')
      },
      showBatchCheck() {
        return this.selectedRowKeys.length > 0 && (this.baseQueryParam.checked === '0' || this.baseQueryParam.checked === '2');
      }
    },
    watch: {
      $route(to, from) {
        if (from.path && from.path.includes('/checkform/')) {
          this.loadData(1)
        }
      }
    },
    mounted(){
      if(!this.batch){
        this.columns.push({
          title: '操作',
          dataIndex: 'action',
          width: 120,
          align: "center",
          fixed:'right',
          scopedSlots: {customRender: 'action'}
        })
      }
      this.baseQueryParam = Object.assign({projectId:this.projectId,checked:'0'},this.baseQuery)
      this.resetSupperParams()
      // this.loadData()
      this.loadSearchData()
      this.loadPeriod()
    },
    methods:{
      onCheckedChange() {
        this.selectedRowKeys = [];
        this.searchQuery();
      },
      callbackGroupName(key) {
        console.log(key);
        this.activeGroupName = key;
        this.addGroupName = undefined
        this.baseQueryParam.groupName = key
        this.searchQueryMy()
      },
      loadSearchData(){
        getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.centerList = res.result
          }
        })
        getAction('/project/projectUser/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.userList = res.result
          }
        })
         getAction('/patient/patientForm/listAllByProjectId',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.checkUserList = res.result
          }
        })
        getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
          }
        })
        getAction('/project/projectForm/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.formList=res.result
          }
        })
      },
      appendTag(tag) {
        console.log(tag)
        this.formCheck.voiceEvaluate = tag
      },

      resetSupperParams(){
        this.$set(this.queryParam2,'centerIdList',[])
        this.$set(this.queryParam2,'personIdList',[])
        this.$set(this.queryParam2,'userIdList',[])
        this.$set(this.queryParam2,'periodItemIdList',[])
        this.$set(this.queryParam2,'formIdList',[])
        this.$set(this.queryParam2,'submitTimeList',[])
        this.$set(this.queryParam2,'checkTimeList',[])
        this.$set(this.queryParam2,'checkUserIdList',[])
        this.$set(this.queryParam,'supper',"")
      },
      searchQueryMy(){
        // this.resetSupperParams()
        this.searchQuery()
      },
      handleView(record){
        this.viewFormId = record.id
        this.viewVisible = true;
      },
      handleSubmit(){
        if(this.formCheck.checked == '1'){
          getAction('/patient/patientForm/checkSubmit',{paFormId:this.formCheck.id}).then(res=>{
              if(res.success){
                if(res.result.length>0){
                  this.$confirm({
                    title: '确认审核',
                    content: (<div>
                      <p>表单存在尚未处理的质疑，确定审核通过吗？</p>
                    </div>),
                    centered: false,
                    onOk: () => {
                      this.handleCheckedSubmit()
                    },
                  })
                }else{
                  this.handleCheckedSubmit()
                }
              }else{
                this.$message.warning(res.message)
              }
            })
        }else{
          this.handleCheckedSubmit()
        }        
      },
      handleCheckedSubmit() { 
        postAction('/patient/patientForm/checked',this.formCheck).then(res=>{
              if(res.success){
                this.loadData()
                this.handleCancel()
                this.$message.success('审核成功！')
              }else{
                this.$message.warning(res.message)
              }
            })
      },
      handleCheck(record) {
        this.checkedVisible = true
        this.formCheck.id = record.id
        return
        getAction('/patient/patientForm/checkSubmit',{paFormId:record.id}).then(res=>{
              if(res.success){
                if(res.result.length>0){
                  return this.$message.warning('存在尚未处理的表单，不能进行审核操作！')
                }else{
                  this.checkedVisible = true
                  this.formCheck.id = record.id
                }
              }
            })
      },
      handleCancel() {
        // this.form.resetFields(); // 重置表单
        this.checkedVisible = false;
      },
      handleAdvancedSubmit(){
        this.$set(this.queryParam,'patientName',null)
        this.$set(this.queryParam,'patientId',null)        
        this.$set(this.queryParam,'input',null)
        this.$set(this.queryParam,'supper',JSON.stringify(this.queryParam2))
        this.periodGroups = []
        this.activeGroupName = ''
        if(!this.addGroupName || this.addGroupName==''){
          this.baseQueryParam.groupName = ''
        }

        if(this.batch){
          if(!this.queryParam2.periodItemIdList || this.queryParam2.periodItemIdList.length ===0){
            return this.$message.warning('请选择周期')
          }
          if(!this.queryParam2.formIdList || this.queryParam2.formIdList.length ===0){
            return this.$message.warning('请选择表单')
          }
          this.$emit('handleSearch',this.queryParam2.formIdList[0])
        }
        this.loadData(1);
        this.handleAdvancedCancel()
      },
      handleAdvancedCancel(){
        this.advancedVisible = false
      },
      supperSearchView(){
        // this.resetSupperParams()
        this.advancedVisible = true
      },
      patientNameClose(){
        this.$set(this.queryParam,'patientName',null)
        this.$set(this.queryParam,'patientId',null)
        this.periodGroups = []
        this.activeGroupName = ''
        if(!this.addGroupName || this.addGroupName==''){
          this.baseQueryParam.groupName = ''
        }
        this.loadData(1)
      },
      loadByPatient(record){
        this.$set(this.queryParam,'patientName',record.name)
        this.$set(this.queryParam,'patientId',record.id)
        this.loadPeriodGroup(record.id)
        this.loadData(1)
      },
      formIdChange(){
        // 批量审核只能选一个
        if(this.batch && this.queryParam2.formIdList.length>0){
          this.$nextTick(()=>{
            this.$set(this.queryParam2,'formIdList',[this.queryParam2.formIdList[this.queryParam2.formIdList.length-1]])
          })
        }
      },
      periodItemIdChange(){
        // 批量审核只能选一个
        if(this.batch && this.queryParam2.periodItemIdList.length>0){
          this.$nextTick(()=>{
            this.$set(this.queryParam2,'periodItemIdList',[this.queryParam2.periodItemIdList[this.queryParam2.periodItemIdList.length-1]])
          })
        }
      },
      loadPeriod(){
        getAction('/project/projectPeriod/getPeriodDetail',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.period = res.result            
          }
        })
      },
      loadPeriodGroup(patientId){
        getAction('/patient/patientPeriodItem/getPeriodGroup',{patientId:patientId}).then(res=>{
          if(res.success){
            this.periodGroups = res.result            
          }
        })
      },
      selectGroup(num){
        this.activeGroupName = ''
        if(this.addGroupName === num){//再次点击取消选中状态
          this.addGroupName = ''
          this.baseQueryParam.groupName = ''
        }else{
          this.addGroupName = num
          this.baseQueryParam.groupName = this.period.groupTypeName + num
        }        
      },
      selectGroup2(){
        this.activeGroupName = ''
        if(this.addGroupName){
          this.baseQueryParam.groupName = this.period.groupTypeName + this.addGroupName
        }else{
          this.baseQueryParam.groupName = ''
        }
      },
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys
      },
      onClearSelected() {
        this.selectedRowKeys = []
      },
      handleBatchCheck() {
        if (this.selectedRowKeys.length === 0) {
          return this.$message.warning('请选择需要审核的表单')
        }
        console.log('ids',this.selectedRowKeys)
        this.checkedVisible = true
        this.formCheck.id = this.selectedRowKeys
        
      },
      handleCheckedSubmit() {
        if (Array.isArray(this.formCheck.id)) {
          // 批量审核
          postAction('/patient/patientForm/batchChecked', {
            ids: this.formCheck.id,
            checked: this.formCheck.checked,
            voiceEvaluate: this.formCheck.voiceEvaluate
          }).then(res => {
            if (res.success) {
              this.loadData()
              this.handleCancel()
              this.selectedRowKeys = []
              this.$message.success('批量审核成功！')
            } else {
              this.$message.warning(res.message)
            }
          })
        } else {
          // 单个审核
          postAction('/patient/patientForm/checked', this.formCheck).then(res => {
            if (res.success) {
              this.loadData()
              this.handleCancel()
              this.$message.success('审核成功！')
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .search-panel{
    text-align: left;
    margin-bottom: 10px;
  }
  .search-item-com{
    margin-left: 5px;
  }
  .advanced-label{
    text-align: right;
  }
  .advanced-row{
    width: 100%;
    margin-bottom: 20px;
  }
  .number-cell {
    text-align: center;
    line-height: 30px; /* 根据需要调整 */
    border: 1px solid #ccc; /* 添加边框 */
    margin-bottom: 8px; /* 调整间距 */
    border-radius: 10px; /* 添加圆角 */
  }
  /* 悬停状态 */
        .number-cell:hover {
            background: #b9babb;
            border-color: #c0c4cc;
            cursor: pointer;
        }

        /* 选中状态 */
        .number-cell.active {
            background: #409eff;
            color: white;
            border-color: #409eff;
        }
</style>